import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactCard = () => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 border border-primary/20">
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="MessageCircle" size={24} className="text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-jakarta font-bold text-lg text-text-primary mb-2">
            Questions About These Terms?
          </h3>
          <p className="text-text-secondary font-inter mb-4">
            We believe in transparency. If anything in these terms is unclear, 
            we're here to explain it in plain English.
          </p>
          
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <Icon name="Mail" size={16} className="text-primary" />
              <span className="text-sm font-inter text-text-primary">
                legal@openbooq.com
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <Icon name="Phone" size={16} className="text-primary" />
              <span className="text-sm font-inter text-text-primary">
                (937) 910-8791
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <Icon name="MapPin" size={16} className="text-primary" />
              <span className="text-sm font-inter text-text-primary">
                Legal Department, 123 Transparency Ave, Austin, TX 78701
              </span>
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-primary/20">
            <Button 
              variant="outline" 
              size="sm"
              iconName="ExternalLink"
              iconPosition="right"
              onClick={() => window.location.href = '/support'}
            >
              Contact Legal Team
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;